import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResizableModule } from 'angular-resizable-element';

import { MessageCenterComponent } from './message-center.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { LoadingModule } from '@app/shared/components/loading/loading.module';
import { ChatsListComponent } from '@app/modules/message-center/chats-list/chats-list.component';
import { ChatsListItemComponent } from '@app/modules/message-center/chats-list-item/chats-list-item.component';
import { MessagesComponent } from '@app/modules/message-center/messages-list/messages.component';
import { SendMessageFormComponent } from '@app/modules/message-center/send-message-form/send-message-form.component';
import { ChatHeaderComponent } from '@app/modules/message-center/chat-header/chat-header.component';
import { ChatComponent } from '@app/modules/message-center/chat/chat.component';
import { ChatMessageComponent } from '@app/modules/message-center/chat-message/chat-message.component';
import { ViewImageComponent } from '@app/modules/message-center/view-image/view-image.component';
import { ChatWindowsComponent } from '@app/modules/message-center/chat-windows/chat-windows.component';
import { CreateNewMessageComponent } from '@app/modules/message-center/create-new-message/create-new-message.component';
import { FormControlNameExport } from '@app/shared/directives/export-control.directive';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TypingUsersComponent } from '@app/modules/message-center/typing-users/typing-users.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldsModule } from '@app/shared/fields';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { FormFieldComponent } from '@app/modules/message-center/shared/components/form-field/form-field.component';
import { UserAvatarComponent } from '@app/shared/components/user-avatar/user-avatar.component';
import { ThinLoaderComponent } from '@app/modules/message-center/shared/components/loader/thin-loader.component';
import { ChatImageComponent } from '@app/modules/message-center/shared/components/chat-image/chat-image.component';
import { ChatDocComponent } from '@app/modules/message-center/shared/components/chat-doc/chat-doc.component';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { TrimInputModule } from '@app/shared/directives/trim-input/trim-input.module';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '@app/shared/shared.module';
import { SelectChipInputComponent } from '@app/shared/components/select-chip-input/select-chip-input.component';
import { FilterPillsComponent } from '@app/shared/components/filter-pills/filter-pills.component';
import { EmptyStatePlaceholderComponent } from '@app/shared/components/empty-state-placeholder/empty-state-placeholder.component';
import { DialogSkeletonComponent } from '@app/shared/components/skeleton/dialog-skeleton/dialog-skeleton.component';

@NgModule({
  declarations: [
    MessageCenterComponent,
    CreateGroupComponent,
    ChatsListComponent,
    ChatsListItemComponent,
    MessagesComponent,
    SendMessageFormComponent,
    ChatHeaderComponent,
    ChatComponent,
    ViewImageComponent,
    CreateNewMessageComponent,
    ChatWindowsComponent,
    TypingUsersComponent,
    ChatMessageComponent,
    FormFieldComponent,
    ChatImageComponent,
    ChatDocComponent,
  ],
  imports: [
    DialogSkeletonComponent,
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    OverlayModule,
    TrimInputModule,
    FormControlNameExport,
    LoadingModule,
    TranslateModule,
    NgSelectModule,
    FormsModule,
    PipesModule,
    DragDropModule,
    ResizableModule,
    MatTooltipModule,
    FieldsModule,
    FileUploadComponent,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatRippleModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    FilterPillsComponent,
    SelectChipInputComponent,
    UserAvatarComponent,
    ThinLoaderComponent,
    EmptyStatePlaceholderComponent
  ],
  exports: [
    MessageCenterComponent,
    ChatComponent,
    ChatsListComponent,
    ChatWindowsComponent,
    CreateGroupComponent,
  ],
})
export class MessageCenterModule {
}
